<template>
  <b-col :sm="bookingsWideView" class="mt-2">
    <div class="card">
      <!-- activeTab={{activeTab}} -- activeOption={{activeOption}}  -->
      <div class="card-header main-card">
        Listado de reservas

        <i v-if="bookingsWideView == 9" 
            class="fa fa-caret-right fa-2x float-right ml-4" 
            @click="toggleWide"
            title="Ampliar la columna"
        ></i>
        <i v-else class="fa fa-caret-left fa-2x float-right ml-4" @click="toggleWide" title="Reducir la columna"></i>
        
        <booking-list
          v-if="this.$route.path == '/app/excursiones/excursiones'"
          :listName="'NoService'"
          :listTitle="'Reservas sin servicio bus excursión'"
          
        />

        <booking-list
          v-if="this.$route.path == '/app/excursiones/pickups'"
          :listName="'NoService'"
          :listTitle="'Reservas sin servicio bus recogida'"
          
        />


        <booking-list
          
          :listName="'Path'"
          :listTitle="'Ruta de los buses'"
          
        />

        <booking-list
          :listName="'Excursion'"
          :listTitle="'Composición buses excursión'"
         
        />
        <booking-list
          v-if="this.$route.path == '/app/excursiones/pickups'"
          :listName="'Pickup'"
          :listTitle="'Composición buses recogida'"
          
        />
        <booking-list
          v-if="this.$route.path == '/app/excursiones/excursiones'"
          :listName="'Activity'"
          :listTitle="'Reservas clasificadas por actividad'"
          
        />
        
        <booking-list
          v-if="this.$route.path == '/app/excursiones/pickups' || this.$route.path == '/app/excursiones/returns'"
          :listName="'Stop'"
          :listTitle="'Reservas por parada'"
          
        />

        
        
      </div>
      
      <div class="card-body">
        <!-- activeTab: {{activeTab}} activeOption: {{activeOption}} -->
       
        <BookingCard :idBus="idBus"  v-if="activeOption != 'Path'" /> 
        <div v-else>
          <buses-path-list 
             />
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
/* eslint-disable */

import BookingCard from "./BookingCard/BookingCard";
import BookingList from "./BookingListButtons/BookingList";

import BookingsUnassigned from "./BookingsUnassigned/BookingsUnassigned";
import BusesPathList from "../BusPath/BusesPathList";
import { mapGetters } from "vuex";

export default {
  components: {
    BookingCard,
    BookingsUnassigned,
    BookingList,
    BusesPathList,
  },
  props: [
    "busId"
  ],
  data() {
    return {
      idBus: "",
      busList: [],
      listActive: this.activeOption,
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
    ...mapGetters(['isDataLoading']),
    ...mapGetters(['bookingsWideView', 'busWideView'])

  },
  methods: {
    async toggleWide() {
      await this.$store.dispatch('layout/toggleBookingsBusWideView')
    }
  },
  watch: {
    busId: function(val) {
      // update bus id to sent to BookingCard child
      if (val) {
        this.idBus = this.busId;
      } else {
        this.idBus = "";
      }
    },
  },
};
</script>